import { RouteName } from "@/app/routing/routing";
import { t } from "@/mixins/i18nMixin";
import { STORE } from "@/store";
import { FEATURE_FLAGS, SERVICE } from "@agentx/agentx-services";
import { Router } from "@uuip/unified-ui-platform";
import { html } from "lit-html";
import style from "./InteractionsBlock.scss";
const InteractionsBlock = () => {
    return new Router.RouterView.Block({
        template: html `
      <div class="interactions-view">
        <agentx-wc-panel-frame heading="${t("app:interactions.interactions")}">
          <agentx-wc-interactions-tab-widget
            .isDarkMode=${STORE.app.darkMode}
            .isRTDIntialized=${STORE.app.isRTDIntialized}
            .interactionsStore=${STORE.interactions}
            .initialCompletedTimeRange=${STORE.session.interactions.initialCompletedTimeRange}
            .initialParams=${STORE.routing.getExtraRouteParams(RouteName.Interactions)}
            .isActionsColumnEnabled=${SERVICE.featureflag.isFeatureFlagEnabled(FEATURE_FLAGS.DESKTOP_ENABLE_INTERACTIONS_VIEW_ACTIONS_COLUMN)}
            @action-button-open-details=${() => {
            STORE.layout.setRouterViewClasses({ expanded: true });
        }}
            @grid-sidebar-toggled=${(e) => {
            STORE.layout.setRouterViewClasses({ "with-sidebar": e.detail.visible });
        }}
            @initial-completed-time-range-changed=${(e) => {
            STORE.session.interactions.setInitialCompletedTimeRange(e.detail.timeRange);
        }}
            @reset-initial-params=${() => {
            STORE.routing.setExtraRouteParams(RouteName.Interactions, {});
        }}
          ></agentx-wc-interactions-tab-widget>
        </agentx-wc-panel-frame>
      </div>
    `,
        styles: [style]
    });
};
export default InteractionsBlock;
